import api from "./api";
import UtilsUrl from "../utils/UtilsUrl";

class RateService {
  addNewRate(rateModel) {
    return api.post(UtilsUrl.rateURL() + "/addRate", rateModel);
  }

  getAllRatesByIdUserAndIsDeleted(idUserCreation, isDeleted) {
    return api.get(
      UtilsUrl.rateURL() +
        "/getAllRatesByIdAndIsDeleted/" +
        idUserCreation +
        "/" +
        isDeleted
    );
  }
  getAllRatesByIdUserAndIsDeletedAndTypeTax(
    idUserCreation,
    isDeleted,
    typeTax
  ) {
    return api.get(
      UtilsUrl.rateURL() +
        "/getAllRatesByIdAndIsDeletedAndTypeTax/" +
        idUserCreation +
        "/" +
        isDeleted +
        "/" +
        typeTax
    );
  }
  archiveRateByIdUserAndIsDeleted(idUserCreation, isDeleted, idRate) {
    return api.delete(
      UtilsUrl.rateURL() +
        "/archiveRate/" +
        idUserCreation +
        "/" +
        isDeleted +
        "/" +
        idRate
    );
  }
}

export default new RateService();
